import PropTypes from 'prop-types';
import Button from 'src/components/Button';
import {
  getApplicationTrustStatusColor,
  getApplicationTrustStatusLabel,
} from 'src/utils/enums/applicationTrustStatus';
import { getDeviceStatusColor, getDeviceStatusLabel } from 'src/utils/enums/deviceStatus';
import {
  getUnmatchedFileStatusColor,
  getUnmatchedFileStatusLabel,
} from 'src/utils/enums/unmatchedFileStatus';

const getStatusColor = status => {
  const deviceColor = getDeviceStatusColor(status);
  if (deviceColor !== '#9E9E9E' || status === 'Unknown') {
    return deviceColor;
  }

  const unmatchedColor = getUnmatchedFileStatusColor(status);
  if (unmatchedColor !== '#9E9E9E') {
    return unmatchedColor;
  }

  return getApplicationTrustStatusColor(status);
};

const getDefaultLabel = status => {
  const deviceLabel = getDeviceStatusLabel(status);
  if (deviceLabel !== 'No Status' || status === 'Unknown') {
    return deviceLabel;
  }

  const unmatchedLabel = getUnmatchedFileStatusLabel(status);
  if (unmatchedLabel) {
    return unmatchedLabel;
  }

  return getApplicationTrustStatusLabel(status);
};

const StatusButton = ({ status, children, outlined = false, sx = {}, ...props }) => {
  const color = getStatusColor(status);

  return (
    <Button
      {...props}
      sx={{
        color: outlined ? color : '#fff',
        border: `1px solid ${color}`,
        backgroundColor: outlined ? 'transparent' : color,
        textTransform: 'none',
        '&:disabled': {
          opacity: 0.5,
          color: outlined ? color : '#fff',
        },
        ...sx,
      }}>
      {children || getDefaultLabel(status)}
    </Button>
  );
};

StatusButton.propTypes = {
  status: PropTypes.string,
  children: PropTypes.node,
  outlined: PropTypes.bool,
  sx: PropTypes.object,
};

export default StatusButton;
